"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blogStore = void 0;
var blog_1 = require("./blog");
Object.defineProperty(exports, "blogStore", { enumerable: true, get: function () { return blog_1.blogStore; } });
//# sourceMappingURL=index.js.map